export enum CapitalizationType {
    MIESIECZNA = "miesieczna",
    KWARTALNA = "kwartalna",
    POLROCZNA = "polroczna",
    ROCZNA = "roczna",
}